/* eslint-disable react/prop-types */
import clsx from "clsx";

import { cn } from "@/lib/utils";
import useChatStore from "@/stores/useChatStore";

import MessageTime from "./MessageTime";
import FeedbackButtons from "./FeedbackButtons";
import ThinkingIndicator from "./ThinkingIndicator";
import TypewriterText, { MarkdownContent } from "./Typewriter";

function AIMessage({ message, isPopupContent, getRatingFeedback, onTextType }) {
  const { conversation, hasDisplayedAnswer } = useChatStore();
  const userMessage = message.content;

  return (
    <div className="flex mt-4 text-left">
      <div className="inline-block max-w-[95%] rounded-lg rounded-tl-none w-full">
        {message.thinkingMessages && message.thinkingMessages.length > 0 && (
          <div className="mb-3">
            <ThinkingIndicator isPopupContent={isPopupContent} isActive={!userMessage} thinkingMessages={message.thinkingMessages} />
          </div>
        )}

        {message.index === conversation.length - 1 && !hasDisplayedAnswer ? (
          <div className="max-w-[95%] w-full">
            <div className={clsx("inline-block p-2 rounded-lg", "rounded-tl-none text-black")}>
              <TypewriterText text={userMessage} useTypewriter={!hasDisplayedAnswer} onType={onTextType} className={cn(isPopupContent ? "text-sm" : "text-md", "prose")} />
            </div>
          </div>
        ) : (
          <>
            <MarkdownContent content={userMessage} className={cn(isPopupContent ? "text-sm" : "text-md", "prose")} />
            <div className="flex items-center">
              <FeedbackButtons messageId={message.index} messageContent={userMessage} initialFeedback={getRatingFeedback(message.rating)} />
              <MessageTime timestamp={message.createTime} className={cn("ml-3")} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AIMessage;
